var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpGaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3931 3.87484L13.1792 4.90602L14.8383 3.94815L13.0522 2.91697L11.3931 3.87484Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.532 6.48107L11.2197 7.23872V8.7822L12.532 8.02454V6.48107Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52014 8.79734V10.3408L10.1793 9.38294V7.83943L8.52014 8.79734Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1793 10.5843L8.52014 11.5422V13.0857L10.1793 12.1278V10.5843Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04035 2.5165L10.3527 3.27416L12.0118 2.31625L10.6995 1.5586L9.04035 2.5165Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 4.63253L9.31225 3.87485L7.99993 3.11719L6.68761 3.87485L7.99993 4.63253Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47968 13.0857V11.5422L5.82055 10.5843V12.1278L7.47968 13.0857Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98802 2.31625L5.64715 3.27416L6.95946 2.5165L5.30033 1.5586L3.98802 2.31625Z",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3527 4.47556L9.04035 5.23322L10.8264 6.2644L12.1387 5.50675L10.3527 4.47556Z",
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5725 7.42383L15.0582 6.56609V5.02259L13.5725 5.88036V7.42383Z",
    fill: "#ffffff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86108 5.50675L5.1734 6.2644L6.95946 5.23322L5.64715 4.47556L3.86108 5.50675Z",
    fill: "#ffffff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78012 8.7822V7.23872L3.4678 6.48107V8.02454L4.78012 8.7822Z",
    fill: "#ffffff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47968 8.79734L5.82055 7.83943V9.38294L7.47968 10.3408V8.79734Z",
    fill: "#ffffff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 7.89631L9.78596 6.86513L7.9999 5.83394L6.21384 6.86513L7.9999 7.89631Z",
    fill: "#ffffff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0582 7.76751L13.5725 8.62526V10.1688L15.0582 9.31098V7.76751Z",
    fill: "#ffffff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99991 1.91578L9.659 0.957905L7.99991 0L6.34077 0.957905L7.99991 1.91578Z",
    fill: "#ffffff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2197 9.98361V11.5271L12.532 10.7694V9.22596L11.2197 9.98361Z",
    fill: "#ffffff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5725 11.3701V13.0831L15.0582 12.2253V10.5124L13.5725 11.3701Z",
    fill: "#ffffff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42734 11.3701L0.94165 10.5124V12.2253L2.42734 13.0831V11.3701Z",
    fill: "#ffffff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82063 4.90602L4.6067 3.87484L2.9476 2.91697L1.16153 3.94815L2.82063 4.90602Z",
    fill: "#ffffff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.532 11.9708L11.2197 12.7285V14.4414L12.532 13.6837V11.9708Z",
    fill: "#ffffff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78012 9.98361L3.4678 9.22596V10.7694L4.78012 11.5271V9.98361Z",
    fill: "#ffffff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42734 8.62526L0.94165 7.76751V9.31098L2.42734 10.1688V8.62526Z",
    fill: "#ffffff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42734 7.42383V5.88036L0.94165 5.02259V6.56609L2.42734 7.42383Z",
    fill: "#ffffff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47968 14.2871L5.82055 13.3292V15.0421L7.47968 16V14.2871Z",
    fill: "#ffffff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1793 13.3292L8.52014 14.2871V16L10.1793 15.0421V13.3292Z",
    fill: "#ffffff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78012 14.4414V12.7285L3.4678 11.9708V13.6837L4.78012 14.4414Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpGaming);
export default __webpack_public_path__ + "static/media/icon-up-gaming.b100cb5fa635ade5c70769ff9064de05.svg";
export { ForwardRef as ReactComponent };